import React, { Component } from 'react';
import classNames from 'classnames';
import { Row, Col, Input } from 'react-bootstrap';

import { Translate } from 'react-redux-i18n';

export default class IsEnabled extends Component {
  render() {
    const titleClass = classNames({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label', 'marginTopStyle', 'textAlignStyle')
    const { input } = this.props;
    return (
      <div>
        <Row><Col sm={12}>{this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}</Col></Row>
        <Row>
          <Col sm={3}>
            <label className={titleClass} ><Translate value="is_enabled" /></label>
          </Col>
          <Col sm={2}>
            <label>
              <Input {...input} type="radio" value={true} checked={input.value === true || input.value === 'true' }/><Translate value="yes" />
            </label>
          </Col>
          <Col sm={2}>
            <label>
              <Input {...input} type="radio" value={false} checked={input.value === false || input.value === 'false' }/><Translate value="no" />
            </label>
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/isEnabled.jsx